// Legal-link footer shared between the dashboard layout (after sign-in)
// and the signup-shell views (before sign-in). The dashboard's view
// of the brand chrome needs the same Terms / Privacy / Cookies /
// Contact links the landing page surfaces in its own footer.

export function Footer() {
  return (
    <footer className="app-footer">
      <div className="app-footer-inner">
        <a href="https://sequesign.com/terms">Terms</a>
        <a href="https://sequesign.com/privacy">Privacy</a>
        <a href="https://sequesign.com/cookies">Cookie Notice</a>
        <a href="https://sequesign.com/do-not-sell">Do Not Sell or Share</a>
        <a href="https://sequesign.com/subprocessors">Sub-processors</a>
        <a href="https://sequesign.com/security">Security</a>
        <a href="https://sequesign.com/dmca">DMCA</a>
        <a href="https://sequesign.com/dpa">DPA</a>
        <a href="https://sequesign.com/changelog">Changelog</a>
        <a href="https://sequesign.com/contact">Contact</a>
      </div>
    </footer>
  );
}
